import React, { Component } from "react";
import SimplifiedLayout from "../SimplifiedLayout";
import { Grid, Col, Row, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import axios from 'axios';
import cookie from 'react-cookie';
import Helmet from 'react-helmet';

class LogoutPage extends Component {

	componentWillMount() {
		cookie.remove("webfinery.jwt", { path: '/' });
        axios.defaults.headers.common["Authorization"] = null;	
    }

    render() {
        return (
            <div>
            	<Helmet title="Logout"/>
                <SimplifiedLayout>
                    <Grid className="text-center">
                        <Row>
                            <Col sm={12}>
                                <h1>
                                    <i
                                        className="fa fa-sign-out fa-3x"
                                        aria-hidden="true"
                                    />
                                </h1>
                                <h2>Come back soon</h2>
                                <h4>
                                    You have been succcessfully logged out
                                </h4>
                                <LinkContainer to="/login">
                                    <Button bsStyle="primary" name="">
                                        Log in
                                    </Button>
                                </LinkContainer>
                            </Col>
                        </Row>

                    </Grid>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default LogoutPage;



// WEBPACK FOOTER //
// ./src/auth/LogoutPage.js